import { styled, Box } from '@withjoy/joykit';
import { PartyIndicator } from '@apps/guestList/GuestList.types';

export const StyledBox = styled(Box)<{ $partyIndicator: PartyIndicator }>`
  padding: 4px;
  ${({ $partyIndicator }) => $partyIndicator === 'head' && 'border: 1px solid #bebebe; border-bottom: none; border-radius: 50% 50% 0 0;'};
  ${({ $partyIndicator }) => $partyIndicator === 'last' && 'border: 1px solid #bebebe; border-top: none; border-radius: 0 0 50% 50%;'};
  ${({ $partyIndicator }) => $partyIndicator === 'middle' && 'border: 1px solid #bebebe; border-bottom: none; border-top: none;'};
`;
